import { FC, useRef } from 'react';

import { Box } from '@mui/material';

import { onOpenEditorFromCopy } from 'store/global/globalSlice';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import { useAppDispatch } from 'app/hooks';
import { CopyViewType } from './types';
import { useTranslation } from 'react-i18next';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { logEventFirebase } from 'utils/config/firebase';
import { copy } from 'helpers/functions';

const CopyView: FC<CopyViewType> = ({ x, y, value, onClose }) => {
    const contextMenuRef = useRef<HTMLDivElement>(null);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    useOnClickOutside(contextMenuRef, onClose);

    const onCopyComposingPad = () => {
        logEventFirebase('click_copy_to_composing_pad');
        copy({ isSelection: true });
        dispatch(onOpenEditorFromCopy(value));
        onClose();
    };

    return (
        <Box
            className="copy-menu"
            ref={contextMenuRef}
            style={{ position: 'absolute', top: `${y}px`, left: `${x}px` }}
        >
            <Box>
                <button onClick={onCopyComposingPad}>
                    <ContentCopyIcon />
                    {t('web_app.context_menu.copy_to_composing_pad')}{' '}
                </button>
            </Box>
        </Box>
    );
};
export default CopyView;
